




















import {
    defineComponent,
    onMounted,
    computed,
    ref,
} from "@nuxtjs/composition-api";
import CmsBlocks from "components/theme/Content/CmsBlocks.vue";
import FooterLogos from "components/theme/Footer/Logos.vue";
import { useConfig } from "@wemade-vsf/composables";

export default defineComponent({
    name: "AppFooter",
    components: {
        CmsBlocks,
        FooterLogos,
    },

    setup() {
        const { config } = useConfig();

        const blockIdentifiers =
            config.value?.storefront?.footer_block_identifier || null;

        const copyright = config.value.copyright ?? "";

        const supportsIntersection = computed(
            () => process.browser && "IntersectionObserver" in window
        );

        const wrapper = ref(null);

        if (process.browser && "IntersectionObserver" in window) {
        }

        onMounted(async () => {
            const footer = document.getElementById("app-footer-container");
            const stickySidebar = document.getElementById("stickySidebar");
            const styles = window.getComputedStyle(document.body);

            function isScrolling() {
                requestAnimationFrame(() => {
                    const siteWidth = styles.getPropertyValue("--site-width");

                    if (parseInt(siteWidth, 10) < 1024) {
                        return;
                    }

                    const distance =
                        document.documentElement.clientHeight -
                        footer.getBoundingClientRect().top;
                    document.documentElement.style.setProperty(
                        "--site-footer",
                        `${distance < 0 ? "0" : distance}px`
                    );
                });
            }

            let navigationObserver: IntersectionObserver | null = null;

            if (process.browser && supportsIntersection) {
                navigationObserver = new IntersectionObserver((entries) => {
                    for (let entry of entries) {
                        if (entry.intersectionRatio > 0) {
                            window.addEventListener("scroll", isScrolling);
                        } else {
                            window.removeEventListener("scroll", isScrolling);
                        }
                    }
                });

                if (stickySidebar && navigationObserver) {
                    navigationObserver.observe(wrapper.value);
                }
            }
        });

        return {
            blockIdentifiers,
            copyright,
            wrapper,
        };
    },
});
